/* istanbul ignore file */
/* tslint:disable */
 
import type { Location } from '../models/Location';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CommonService {

  /**
   * @returns any 
   * @throws ApiError
   */
  public static commonHealthRetrieve(): CancelablePromise<Record<string, any>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/health/',
    });
  }

  /**
   * API endpoint for querying locations by hierarchical level.
 *
 * Query parameters:
 * - No params: returns countries (Level 1)
 * - country=MD: returns districts (Level 2)
 * - country=MD&district=0333: returns localities (Level 3)
   * @param country Country ID (e.g., MD)
   * @param district District ID (e.g., 0333)
   * @returns Location 
   * @throws ApiError
   */
  public static commonLocationsList(
country?: string,
district?: string,
): CancelablePromise<Array<Location>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/locations/',
      query: {
        'country': country,
        'district': district,
      },
    });
  }

  /**
   * @returns any Countries dictionary with country code as key and translated name as value
   * @throws ApiError
   */
  public static commonLocationsCountriesRetrieve(): CancelablePromise<Record<string, any>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/locations/countries/',
    });
  }

}
